import React, { useMemo, useState } from "react";
const CDN = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple@15.1.2/img/apple/64/";
const EMOJI_RE = /(\p{Extended_Pictographic}\uFE0F?(?:\u200D\p{Extended_Pictographic}\uFE0F?)*)/gu;
const IGNORED = new Set(["©", "®", "™"]);
function toCode(emoji: string) {
  return Array.from(emoji).map(c => (c.codePointAt(0) ?? 0).toString(16)).join("-");
}
type EmojiProps = {
  char: string;
  className?: string;
};

/** Renderiza un emoji con el diseño de Apple (iPhone) */
export function Emoji({
  char,
  className = ""
}: EmojiProps) {
  const candidates = useMemo(() => {
    const code = toCode(char);
    const stripped = code.replace(/-fe0f/g, "");
    return Array.from(new Set([code, stripped, `${stripped}-fe0f`]));
  }, [char]);
  const [attempt, setAttempt] = useState(0);
  if (attempt >= candidates.length) return <span className={className} data-id="element-29" data-mp="2hx0j2wxl4906">{char}</span>;
  return <img src={`${CDN}${candidates[attempt]}.png`} alt={char} draggable={false} onError={() => setAttempt(a => a + 1)} className={`inline-block h-[1.15em] w-[1.15em] align-[-0.2em] ${className}`} data-id="element-30" data-mp="2dwgq85k1nrju" />;
}
type EProps = {
  children: string;
};

/** Texto con emojis estilo iPhone */
export function E({
  children
}: EProps) {
  const parts = children.split(EMOJI_RE);
  return <>
      {parts.map((part, i) => i % 2 === 1 && !IGNORED.has(part) ? <Emoji key={i} char={part} data-id="element-31" data-mp="1vl09k3wnmnb1" /> : <React.Fragment key={i} data-id="element-32" data-mp="20itfqwxyjhbb">{part}</React.Fragment>)}
    </>;
}